import { useState } from 'react';
import { FilterType } from '../FilterData';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  CancleButton,
  Wrapper,
} from '../filterOptionModal/OptionModal.styles';
import { styled } from 'styled-components';

interface Props {
  option: 'buildingArea' | 'landArea';
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function AreaOption({ option, onClose, filters, setFilters }: Props) {
  const [minInput, setMinInput] = useState(filters[option]?.min || '');
  const [maxInput, setMaxInput] = useState(filters[option]?.max || '');

  const [unit, setUnit] = useState<'m2' | 'pyeong'>('m2');

  const togglePyeongM2Value = (value: string, unit: string) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return unit === 'pyeong'
      ? (num * 3.30579).toFixed(2)
      : (num / 3.30579).toFixed(2);
  };

  const toggleUnit = () => {
    const toUnit = unit === 'm2' ? 'pyeong' : 'm2';
    setUnit(toUnit);

    if (minInput !== '') {
      setMinInput(togglePyeongM2Value(minInput, unit));
    }

    if (maxInput !== '') {
      setMaxInput(togglePyeongM2Value(maxInput, unit));
    }
  };

  const handleReset = () => {
    onClose();
  };
  const handleSubmit = () => {
    const minValue =
      minInput && unit === 'pyeong'
        ? (parseFloat(minInput) * 3.30579).toFixed(2).toString()
        : minInput;
    const maxValue =
      maxInput && unit === 'pyeong'
        ? (parseFloat(maxInput) * 3.30579).toFixed(2).toString()
        : maxInput;

    setFilters({
      ...filters,
      [option]: {
        min: minValue || '',
        max: maxValue || '',
      },
    });
    onClose();
  };
  return (
    <Wrapper>
      <OptionBox>
        <Title>
          {option === 'buildingArea' ? '건물면적' : '토지면적'}
          <ChangeUnitButton onClick={() => toggleUnit()}>
            {unit === 'm2' ? 'm²' : '평'}
          </ChangeUnitButton>
        </Title>

        <Inner>
          <UnitInputWrapper>
            <NumberInput
              type="text"
              inputMode="decimal"
              pattern="[0-9.]*"
              style={{ padding: 0, borderRadius: 0 }}
              placeholder="최소"
              value={minInput}
              onChange={(e) => setMinInput(e.target.value)}
            />
            <span style={{ whiteSpace: 'nowrap' }}>
              {unit === 'm2' ? 'm²' : '평'}
            </span>
          </UnitInputWrapper>
          <Text>~</Text>
          <UnitInputWrapper>
            <NumberInput
              type="text"
              inputMode="decimal"
              placeholder="최대"
              pattern="[0-9.]*"
              style={{ padding: 0, borderRadius: 0 }}
              value={maxInput}
              onChange={(e) => setMaxInput(e.target.value)}
            />
            <span style={{ whiteSpace: 'nowrap' }}>
              {unit === 'm2' ? 'm²' : '평'}
            </span>
          </UnitInputWrapper>
        </Inner>
      </OptionBox>
      <Bottom>
        <ButtonBox>
          <CancleButton onClick={handleReset}>취소</CancleButton>
          <ApplyButton onClick={handleSubmit}>저장</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default AreaOption;

const OptionBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 12px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: row;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
`;

const NumberInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  border: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  &::placeholder {
    color: #616161;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
  }
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

const ChangeUnitButton = styled.button`
  border-radius: 4px;
  padding: 2px 6px;
  border: 1px solid #70737c38;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #222;
  background-color: #fff;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
